"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleImageUrl404 = handleImageUrl404;
exports.getFileNameFromUrl = getFileNameFromUrl;

function handleImageUrl404(imageUrl, errorHandler, loadHandler) {
  var img = new Image();

  img.onload = function () {
    loadHandler();
  };

  img.onerror = function () {
    errorHandler(null);
  };

  img.src = imageUrl;
}

function getFileNameFromUrl(imageUrl) {
  var regex = imageUrl.match(/([^\/]*)\/*$/);
  return regex && regex.length === 2 ? regex[1] : imageUrl;
}